import Ajax from '../ajax';

export default {
  list: (data) => Ajax('get', 'popularProductUrl', data),
  get: (id) => Ajax('get', `popularProductUrl/${id}`),
  create: (data) => Ajax('post', 'popularProductUrl', data),
  update: (id, data) => Ajax('put', `popularProductUrl/${id}`, data),
  enable: (id) => Ajax('put', `popularProductUrl/${id}/enable`),
  disable: (id) => Ajax('put', `popularProductUrl/${id}/disable`),
  delete: (id) => Ajax('delete', `popularProductUrl/${id}`),
};
